import React, { useEffect, useState } from 'react';
import { Select } from '@vtblife/uikit';
import axios from '@vtblife/axios';
import styles from './region-suggest.module.css';
import { InputControl } from './input-control';
import { useDebounce } from '../../../utils/use-debounce';
import { geoApiService } from '../../../utils/geo-api';
const DEBOUNCE_DELAY = 300;
export const RegionSuggest = ({ value, onChange }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const debouncedInputValue = useDebounce(inputValue, DEBOUNCE_DELAY);
    const inputControlValue = value && 'label' in value ? value.label : inputValue;
    const handleInputChange = (inputValue) => {
        value && onChange('');
        setInputValue(inputValue);
    };
    const handleInputReset = () => {
        value && onChange('');
        setSuggestions([]);
    };
    useEffect(() => {
        if (!debouncedInputValue)
            return;
        const source = axios.CancelToken.source();
        geoApiService
            .getGeoSuggest(debouncedInputValue, source.token)
            .then(({ data }) => {
            setSuggestions(data !== null && data !== void 0 ? data : []);
        })
            .catch((error) => {
            if (axios.isCancel(error))
                return;
        });
        return source.cancel;
    }, [debouncedInputValue]);
    return (React.createElement(Select, null,
        React.createElement(InputControl, { value: inputControlValue, onChange: handleInputChange, onReset: handleInputReset, hasSuggestions: Boolean(suggestions.length) }),
        React.createElement(Select.Content, { bounds: true, placement: "local" },
            React.createElement("div", { className: styles.suggestions, "data-test": "select-region-quiz-suggest-list" }, suggestions.map((item, index) => (React.createElement("div", { key: item.value, className: styles.suggestion, "data-test": `select-region-quiz-suggest-item-${index}`, onClick: () => {
                    onChange(item);
                    setSuggestions([]);
                } },
                React.createElement("div", { className: styles.suggestionTitle }, item.label),
                item.narrowRegion && (React.createElement("div", { className: styles.suggestionDescription }, item.narrowRegion.name)))))))));
};
//# sourceMappingURL=region-suggest.js.map